
import { Component, Ref, Vue } from "vue-property-decorator";
import { capitalize, findIndex, forEach, get, isEmpty } from "lodash";
import Utils from "@/mixin";
import { Reward, VForm } from "@/type";

@Component({
  props: {
    editId: {
      type: [Number, String],
      default: "",
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    toggleDialog: {
      type: Function,
      // eslint-disable-next-line
      default: /* istanbul ignore next */ () => {},
    },
    setInitialDialog: {
      type: Function,
      // eslint-disable-next-line
      default: /* istanbul ignore next */ () => {},
    },
  },
  mixins: [Utils],
  computed: {
    validate() {
      const { title, detail, categoryId, redeemPoint, image, shopType } = this.formData;
      if (
        (this.editId === "" &&
          (isEmpty(title) ||
            get(detail, "length") === 0 ||
            get(shopType, "length") === 0 ||
            categoryId === "" ||
            redeemPoint === 0 ||
            image === undefined)) ||
        (this.editId !== "" &&
          (isEmpty(title) ||
            get(detail, "length") === 0 ||
            get(shopType, "length") === 0 ||
            categoryId === "" ||
            redeemPoint === 0))
      ) {
        return true;
      } else {
        return false;
      }
    },
    categoryItems() {
      const arrayList: any = []; // eslint-disable-line
      forEach(this.rewardCategoryList, (i) => {
        arrayList.push({ text: i.title, value: i.id });
      });
      return arrayList;
    },
    shopTypeItems() {
      const arrayList: any = []; // eslint-disable-line
      forEach(this.shopTypeList, (i) => {
        arrayList.push({ text: capitalize(i.type), value: i.id });
      });
      return arrayList;
    },
    shopCategoryItems() {
      const arrayList: any = []; // eslint-disable-line
      arrayList.push({ text: "None", value: "None" });
      forEach(this.shopCategoryList, (i) => {
        arrayList.push({ text: i, value: i });
      });
      return arrayList;
    },
  },
  mounted() {
    this.getInitialData();
  },
  watch: {
    editId(nextProps, prevProps) {
      /* istanbul ignore else */
      if (prevProps !== nextProps && nextProps !== "") {
        this.modalTitle = "Edit";
        const { rewardList } = this;
        const index = findIndex(rewardList, (i: Reward) => i.id === nextProps);
        const data = rewardList[index];
        const shopType: any = []; // eslint-disable-line
        let includeTag = null;
        let excludeTag = null;
        forEach(data.shopCategoryReward, (i) => {
          includeTag = i.include;
          excludeTag = i.exclude;
          shopType.push(i.shopTypeId);
        });

        this.formData = {
          title: data.title,
          detail: data.detail,
          categoryId: data.categoryId,
          redeemPoint: data.redeemPoint,
          // redeemAble: data.redeemAble,
          isLimitQty: data.isLimitQty,
          limitedQty: data.limitedQty,
          isLimitPerUser: data.limitPerUser > 0,
          limitPerUser: data.limitPerUser,
          shopType,
          shopCategory: data.shopCategoryReward,
          includeTag,
          excludeTag,
        };
      }
    },
  },
})
export default class RewardForm extends Vue {
  modalTitle = "Create";
  formData = {
    title: "",
    detail: "",
    categoryId: "",
    redeemPoint: 0,
    // redeemAble: false,
    isLimitQty: false,
    limitedQty: 0,
    isLimitPerUser: false,
    limitPerUser: 0,
    image: undefined,
    shopType: [],
    includeTag: null,
    excludeTag: null,
  };
  initialForm = {
    title: "",
    detail: "",
    categoryId: "",
    redeemPoint: 0,
    // redeemAble: false,
    isLimitQty: false,
    limitedQty: 0,
    isLimitPerUser: false,
    limitPerUser: 0,
    image: undefined,
    shopType: [],
    includeTag: null,
    excludeTag: null,
  };
  radioItems = [
    { text: "Yes", value: true },
    { text: "No", value: false },
  ];
  /* istanbul ignore next */
  rules = {
    required: (value: [number, string]) => !!value || "Required.",
    min: (value: number) => value > 0 || "Point must more than 0",
    minLimitedQty: (value: number) =>
      value > 0 || "Limited Quantity must more than 0",
    minLimitPerUser: (value: number) =>
      value > 0 || "Limit Per User must more than 0",
  };

  @Ref("form") readonly form!: VForm;
  getRewardCategory!: (searchForm?: object) => void;
  getShopType!: () => void;
  getShopCategory!: () => void;
  createReward!: (formData: object) => void;
  editReward!: (formData: object) => void;
  toggleDialog!: () => void;

  getInitialData() {
    const searchForm = {
      type: "shop",
    };
    this.getRewardCategory(searchForm);
    this.getShopType();
    this.getShopCategory();
  }

  clearData() {
    if (this.$props.editId !== "") this.$props.setInitialDialog();
    this.toggleDialog();
    this.$nextTick(() => {
      this.modalTitle = "Create";
      this.formData = Object.assign({}, this.initialForm);
      /* istanbul ignore next */
      if (this.form) this.form.resetValidation();
    });
  }

  submitForm() {
    const { formData } = this;
    formData.limitPerUser = formData.isLimitPerUser ? formData.limitPerUser : 0;
    if (this.$props.editId !== "") {
      const form = {
        ...formData,
        type: "shop",
        shopType: JSON.stringify(formData.shopType),
        editId: this.$props.editId,
        includeTag: formData.includeTag === null || formData.includeTag === "None" ? "" : formData.includeTag,
        excludeTag: formData.excludeTag === null || formData.excludeTag === "None" ? "" : formData.excludeTag,
      };
      this.editReward(form);
    } else {
      const form = {
        ...formData,
        shopType: JSON.stringify(formData.shopType),
        type: "shop",
        includeTag: formData.includeTag === null || formData.includeTag === "None" ? "" : formData.includeTag,
        excludeTag: formData.excludeTag === null || formData.excludeTag === "None" ? "" : formData.excludeTag,
      };
      this.createReward(form);
    }
    this.clearData();
  }
}
